import { render, staticRenderFns } from "./PatentCard.vue?vue&type=template&id=2c3046f6&scoped=true"
import script from "./PatentCard.vue?vue&type=script&lang=js"
export * from "./PatentCard.vue?vue&type=script&lang=js"
import style0 from "./PatentCard.vue?vue&type=style&index=0&id=2c3046f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3046f6",
  null
  
)

export default component.exports